// dependencies
import { List, Map } from "immutable";
import { createSelector } from "reselect";

// utils
import ShortId from "../utils/ShortId";

// constants
import { getOptionById } from "../constants/EmployeePickerPrepend";

export const getWorkflowsStore = (state) => state.workflows;
export const getWorkflowTemplateObject = (state, workflowID) =>
	getWorkflowsStore(state).getIn(["fetchedWorkflows", workflowID], Map());
export const getWorkflowActorsMap = (state, workflowID) =>
	getWorkflowsStore(state).getIn(["fetchedWorkflows", workflowID, "templateActorsMap"], Map());

/**
 * Gets the template object: this includes the workflow name and a list of
 * todos. The todos are populated with a fake id. The actor field is either a
 * user id or a string that is self, manager, or other. This actor field will
 * be replaced with a Map that can be consumed by the AjaxInput ( remember, if
 * the value of the AjaxInput is a Map(), it will assume that value has been
 * selected and so it will display it like so - with an avatar image ).
 * Additionally, each todo can have a document attached to it. If a todo has an
 * ID in the `documentSigning` key, change that to a map like the actor input.
 *
 * @param {object} state
 * @param {string} workflowID - ID of the workflow
 */
export const getWorkflowTemplate = createSelector([getWorkflowTemplateObject], (workflowObject) => {
	const template = workflowObject.get("template", Map()).withMutations((mutable) => {
		mutable.getIn(["todos"], List()).forEach((todo, ii) => {
			const actorID = todo.get("actor");
			let userObject = getOptionById(actorID);

			// If the userObject is undefined, that means it is an employee
			// and not a prepended option (other, manager, etc.)
			if (userObject === undefined) {
				userObject = workflowObject.getIn(["templateActorsMap", actorID], actorID);

				// if for some reason the user was not found, userObject
				// will then be a string
				if (Map.isMap(userObject)) {
					userObject = userObject.set("id", actorID);
				}
			}

			let documentObject = workflowObject.getIn(["templateSignaturesMap", todo.get("documentSigning")], null);

			// signers is a list of self, manager, other. This transforms
			// those into Maps for ajax picker values.
			if (documentObject) {
				const steps = documentObject.get("signers").map((signer, jj) =>
					Map({
						signer: getOptionById(signer),
						index: jj,
					})
				);
				documentObject = documentObject.set("steps", steps);
				documentObject = documentObject.set("id", todo.get("documentSigning"));
				documentObject = documentObject.delete("signers");
			}

			mutable.setIn(["todos", ii, "id"], ShortId());
			mutable.setIn(["todos", ii, "actor"], userObject);
			mutable.setIn(["todos", ii, "documentSigning"], documentObject);
		});
	});

	return template;
});
